import { render, staticRenderFns } from "./MensageConsultaPlaca.vue?vue&type=template&id=57c2242b"
import script from "./MensageConsultaPlaca.vue?vue&type=script&lang=js"
export * from "./MensageConsultaPlaca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports